import AuditPlugin from './audit';
import { ConfigAudit } from './types';

export { ConfigAudit };

export default AuditPlugin;
